module.exports = __webpack_public_path__ + "media/assets/rudy-f9ec7ed5f60ac22d2c637de9903607da.jpg";